import React from "react";
import GoogleReviews from "../reviews/GoogleReviews";

const reviews = [
    {
        author: "špela rot",
        quote: "Fantastično! Škratek je navdusil otroke!",
    },
    {
        author: "Stanislava Radunovic",
        image: "/images/reviews/stanislava-radunovic-google-review.png",
        imageViewBox: "7 25 34 34",
        imageWidth: 501,
        imageHeight: 181,
        quote: "Zanimivo. Čudoviti kapniki.",
    },
    {
        author: "lara lesnjek",
        quote: "Res vredno ogleda, vodenje izvedeno zelo profesionalno.",
    },
    {
        author: "Ivka Perko",
        quote: "Zanimivo in vredno ogleda!",
    },
    {
        author: "Janja devesci",
        excerpt:
            "Kam bi šli v soboto? Pa pojdimo v rudnik Sitarjevec v Litijo.",
        quote: "Kam bi šli v soboto? Pa pojdimo v rudnik Sitarjevec v Litijo. No, malce nam je katal po Google, drugače pa je bilo kar nekaj cestnih tabel do tam. Dobili smo kombinezon, zaščitno čelado z lučko, škornje, sponko za pripenjanje, skratka za varnost je poskrbljeno. Imeli smo cudovito vodička, ki nam je razložila kako težko so delali rudarji v tem rudniku železa in svinca. Slišali smo mnogo zgodb, videli smo tudi netopirjev, ki živijo tukaj. Videli smo tudi čudovite jaslice, kapniki iz železa, več rovov, ki so deloma zasuti, .. Na tleh je ponekod stala Voda, tako, da so škornji se kako prišli prav. Marsikje smo morali malo spomniti glave, kajti strop je bil precej nižji kot nase glave...Kogar zanima naj si ogleda njihovo spletno stran. Ogledi so možni po predhodni prijavi. +386 70 700 484.",
    },
    {
        author: "Vesna Hvala",
        image: "/images/reviews/vesna-hvala-google-review.png",
        imageViewBox: "18 24 34 34",
        imageWidth: 539,
        imageHeight: 170,
        quote: "Vredno ogleda čisto okolje in fantastično za pohod na sitarjevec",
    },
    {
        author: "janez gomzi",
        image: "/images/reviews/janez-gomzi-google-review.png",
        imageViewBox: "16 25 34 34",
        imageWidth: 499,
        imageHeight: 182,
        quote: "Zanimiva izkušnja, vredno ogleda, ...",
    },
    {
        author: "Marija Urankar Murn",
        quote: "Vse odlično. Vodič, rudnik, ročno izdelane jaslice. Zelo priporočam ogled",
    },
    {
        author: "Anica Resnik",
        quote: "Zelo lepo urejeno.",
    },
    {
        author: "Gordan Ponjavic",
        image: "/images/reviews/gordan-ponjavic-google-review.png",
        imageViewBox: "10 25 34 34",
        imageWidth: 520,
        imageHeight: 182,
        quote: "Zanimljiv ogled, za popoldanski izlet",
    },
];

function GoogleReviewsSection() {
    return (
        <GoogleReviews
            title="Doživetja, ki ostanejo v spominu"
            description="Preberite, kako so obiskovalci doživeli podzemni svet Rudnika Sitarjevec."
            reviews={reviews}
            labels={{
                fiveStars: "5 od 5 zvezdic",
                googleLink: "Vse ocene na Googlu",
                readFullReview: "Preberi celotno oceno",
            }}
        />
    );
}

export default GoogleReviewsSection;
